import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loading", "content", "error"]
  static values = {
    url: String,
    mode: String
  }

  connect() {
    if (this.modeValue === "retry") return

    this.load()
  }

  async load() {
    this.showLoading()

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      })

      const payload = await response.json()
      if (!response.ok) {
        throw new Error(payload.error || "Request failed")
      }

      this.render(payload)
    } catch (error) {
      this.showError(error.message)
    }
  }

  render(payload) {
    if (payload.mode === "enable") {
      this.contentTarget.innerHTML = this.enableHtml(payload)
    } else if (payload.mode === "fallback") {
      this.contentTarget.innerHTML = this.fallbackHtml(payload)
    } else if (payload.mode === "retry") {
      this.contentTarget.innerHTML = this.retryHtml(payload)
    }

    this.hideLoading()
    this.contentTarget.hidden = false
  }

  enableHtml(payload) {
    const includes = payload.includes.map((item) => `<li>${this.escape(item)}</li>`).join("")
    return `
      <p class="m-0 text-sm text-ink">${this.escape(payload.pricing_lead)}</p>
      <ul class="m-0 list-disc space-y-1 pl-5 text-sm text-muted">${includes}</ul>
      <a href="${this.escape(payload.primary.url)}" class="pro-btn pro-btn--primary">${this.escape(payload.primary.cta)}</a>
    `
  }

  fallbackHtml(payload) {
    const fallbacks = payload.fallbacks.map((option) => `
      <a href="${this.escape(option.url)}" class="pro-btn pro-btn--secondary pro-btn--small">${this.escape(option.cta)}</a>
    `).join("")

    return `
      <div class="mt-3 space-y-3 rounded-lg border border-border bg-surface px-4 py-3">
        <p class="m-0 text-sm text-ink">${this.escape(payload.lead)}</p>
        <div class="flex flex-wrap gap-2">${fallbacks}</div>
        <p class="m-0 text-xs text-muted">${this.escape(payload.or_label)}</p>
        <a href="${this.escape(payload.primary.url)}" class="pro-btn pro-btn--secondary pro-btn--small">${this.escape(payload.primary.cta)}</a>
      </div>
    `
  }

  retryHtml(payload) {
    return `
      <a href="${this.escape(payload.primary.url)}" class="pro-btn pro-btn--secondary pro-btn--small">${this.escape(payload.primary.cta)}</a>
    `
  }

  showLoading() {
    if (this.hasLoadingTarget) this.loadingTarget.hidden = false
    if (this.hasContentTarget) this.contentTarget.hidden = true
    if (this.hasErrorTarget) this.errorTarget.hidden = true
  }

  hideLoading() {
    if (this.hasLoadingTarget) this.loadingTarget.hidden = true
  }

  showError(message) {
    this.hideLoading()
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = message
    this.errorTarget.hidden = false
  }

  escape(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll("\"", "&quot;")
  }
}
